<template>
  <div id="app" class="app-content mb-4">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <b-card-group deck>
            <SettingsMenu></SettingsMenu>
            <KycInfo></KycInfo>
            <MainBalance></MainBalance>
          </b-card-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "../reuseable_components/Header.vue";
import SettingsMenu from "./SettingsMenu.vue";
import MainBalance from "./MainBalance.vue";
import KycInfo from "./KycInfo.vue";

export default {
  name: "Kyc",
  components: {
    "app-header": AppHeader,
    SettingsMenu: SettingsMenu,
    MainBalance: MainBalance,
    KycInfo: KycInfo,
  },
};
</script>
<style lang="scss">
</style>
